export const coupleColors: Record<
  number,
  {
    fillColor: string;
    label: string;
  }
> = {
  1: {
    fillColor: "#FFFFFF",
    label: "White",
  },
  2: {
    fillColor: "#000000",
    label: "Black",
  },
  3: {
    fillColor: "#FFEF30",
    label: "Yellow",
  },
  4: {
    fillColor: "#FF9700",
    label: "Orange",
  },
  5: {
    fillColor: "#FF3600",
    label: "Red",
  },
  6: {
    fillColor: "#008BFF",
    label: "Blue",
  },
  7: {
    fillColor: "#23DE3F",
    label: "Green",
  },
  8: {
    fillColor: "#C023EA",
    label: "Purple",
  },
};
